import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { PassengerNonSocialMediaIcons } from "./Icons/NonSocialMediaIcons";
import { PassengerSocialMediaIcons } from "./Icons/SocialMediaIcons";
export const WebAppFooterIcons = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const items = [
    {
      label: "Service Portals",
      key: "servicePortals",
      children: <PassengerNonSocialMediaIcons />,
    },
    {
      label: "Social Media",
      key: "socialMedia",
      children: <PassengerSocialMediaIcons />,
    },
  ];

  return (
    <Tabs
      activeKey={query?.get("thirdSubActiveTab") || ""}
      items={items}
      onChange={(activeKey) => {
        navigate(
          `${window.location.pathname}?activeTab=passengerFooter&subActiveTab=webAppFooterIcons&thirdSubActiveTab=${activeKey}`
        );
      }}
    ></Tabs>
  );
};
